// extracted by mini-css-extract-plugin
module.exports = {"container":"BrokenCart_container__P5Vc8","cartText":"BrokenCart_cartText__tw6_0"};